import React from 'react';
import * as S from './Button.style';
export const Button = ({ children, disabled, size = 'default', onClick, block = false, negative = false, ghost = false, ...rest }) => (React.createElement(S.Button, Object.assign({ onClick: onClick, block: block, size: size, disabled: disabled, negative: negative, ghost: ghost }, rest), children));
//# sourceMappingURL=Button.js.map